import StaticImage from './StaticImage';

export type {IStaticImageProps} from './types';
export default StaticImage;
